import React, { FC } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import CombinedEventComponent from './CombinedEventComponent';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';

interface CombinedEventProps extends NavigationProps {}

const CombinedEvent: FC<CombinedEventProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <CombinedEventComponent />
    </MachinesProvider>
  );
};

export { CombinedEvent };
